/**
 * SummaryBar component displays a summary of worker assignments for each day of the
 * week. It uses the DispatchContext to get the necessary data and renders a grid of
 * DispatchDayDetails components, one for each day. It also includes the DispatchModal for sending
 * messages to workers. The same modal is used for every day, with different inputs.
 *
 * @component
 * @returns {JSX.Element} The rendered SummaryBar component.
 *
 * @example
 * return (
 *   <SummaryBar />
 * )
 */
import React, { useContext } from "react";
import { DispatchContext } from "../../../../context/domain/planning/DispatchContext";
import { WeeklyContext } from "../../../../context/global/WeeklyContext";

import DispatchDayDetails from "./DispatchDayDetails";
import { workerAssignmentsByDay } from "../../../../utils/business";

const SummaryBar = () => {
  const { showWeekends, scopes, jobs, datesOfWeek } = useContext(WeeklyContext);
  const { workers } = useContext(DispatchContext);

  // This data conversion makes the API data much easier to read and work with
  // considering the conbtext of this component.
  const workerAssignments = workerAssignmentsByDay(datesOfWeek, scopes, jobs);

  return (
    workerAssignments &&
    workers && (
      <div
        className={`grid ${showWeekends ? "grid-cols-7" : "grid-cols-5"} gap-0 mx-1`}
      >
        {datesOfWeek.map((date, index) => (
          <div
            key={index}
            className="text-gray-900 text-sm text-center m-1 my-2"
          >
            <DispatchDayDetails
              workerAssignments={workerAssignments[index]}
              availableWorkers={workers}
              index={index}
              date={date}
            />
          </div>
        ))}
      </div>
    )
  );
};

export default SummaryBar;
